// extracted by css-extract-rspack-plugin
export default {"cls1":"DownloadOptionCard-cls1_6hW","cls2":"DownloadOptionCard-cls2_5SJ DownloadOptionCard-cls1_6hW"};